<div class="bulkUpload-parent container">
  <!-- <div class="bulkUpload-title">
      <h6 class="bulkUpload-home">home</h6>
      <h3 class="bulkUpload-Titletext">Bulk Order</h3>
    </div> -->
  <mat-tab-group [selectedIndex]="selectedIndex">
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="material-icons">content_paste</i>
        <span>{{ "bulkorder.uplaodpaste" | cxTranslate }}</span>
      </ng-template>
      <div class="bulkUpload text-content vs-text-area">
        <div class="label">{{ "bulkorder.uploadpastelabel" | cxTranslate }}</div>
        <textarea
          class="upload-content"
          placeholder='{{ "bulkorder.uploadtypeplaceholder" | cxTranslate }}'
          [(ngModel)]="content"
          name="content"
          (keyup)="partEntered()"
          (ngModelChange)="stopCount($event)"
        ></textarea>
        <div *ngIf="this.showTextError" class="text-danger">
          {{ "bulkorder.uploadppartno" | cxTranslate }}
        </div>
        <div *ngIf="this.incorrectNo" class="text-danger">
          {{ "bulkorder.uploadpartnumbertext" | cxTranslate }}
        </div>
        <button class="vs-primary-btn paste-btn" [disabled]='disabledClass' (click)="uploadContent()">
          <span>{{ "bulkorder.uploadcheck" | cxTranslate }}</span>
        </button>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="material-icons">cloud_upload</i>
        <span>{{ "bulkorder.uploadcsv" | cxTranslate }}</span>
      </ng-template>
      <div class="bulkUpload text-content">
        <div class="bulkUpload-text">
          <span>{{ "bulkorder.uploadcsvlabel" | cxTranslate }}</span>
        </div>

        <!--FILE UPLOAD STARTS-->

        <div class="custom-margin-auto">
          <label class="custom-upload" for="demofile">
            <input
              class="hidden upload-input"
              multiple
              id="demofile"
              type="file"
              (change)="upload($event)"
            />
            <i class="material-icons custom-upload-icon">backup</i>{{ "bulkorder.uploadup" | cxTranslate }}
          </label>
        </div>
        <div class="doc-width" id="documentClose" #documentClose>
          <div id="docInner" class="section-document">
            <div
              id="fileInfo"
              class="custom-display-bulk-order"
              #fileInfo
              class="fileInfo-section"
            ></div>
            <p
              class="section-document-document-details error-msg custom-display-bulk-order"
              id="fileMaxLenghtExceed"
              #fileMaxLenghtExceed
            ></p>
            <p
              id="fileSizeExceed"
              #fileSizeExceed
              class="section-document-document-details error-msg custom-display-bulk-order"
            ></p>
            <p
              id="fileType"
              #fileType
              class="section-document-document-details error-msg"
            ></p>
            <p
              id="fileDuplicate"
              #fileDuplicate
              class="section-document-document-details error-msg custom-display-bulk-order"
            ></p>
          </div>
        </div>

        <!--FILE UPLOAD ENDS-->

        <!-- <input class="csv-upload" style="display: none" type="file"  #hiddenfileinput>
            <div class="bulkUpload-button" role="“button”">
              <span role="“button”">
                <i class="material-icons" role="“button”"> cloud_upload </i> upload
              </span>
            </div> -->

        <div class="bulkUpload-maxParts">
          {{ "bulkorder.uploaderror" | cxTranslate }}
        </div>
        <!-- <div class="bulkUpload-fileLoader"> -->
        <!-- <div class="progress" *ngIf="progress">
              <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
                [style.width]="{ width: progress + '%' }"
              ></div>
              <span>{{ progress }}%</span>
            </div>
          </div> -->

        <div class="progress" *ngIf="progressInfo">
          <div class="progress-bar" [style.width]="progressInfo + '%'"></div>
        </div>
        <div class="progress-percent" *ngIf="progressInfo">
          {{ progressInfo }}%
        </div>
        <div class="bulkUpload-template">
          <span role="“button”" (click)="downloadSaveCart()"
            ><em class="icons download icon-size"></em> {{ "bulkorder.downloadcsv" | cxTranslate }}
          </span>
        </div>
      </div>
    </mat-tab>
    <!-- <mat-tab>
      <ng-template mat-tab-label>
        <i class="material-icons">format_list_bulleted</i>
        <span>{{ "bulkorder.uploadenter" | cxTranslate }}</span>
      </ng-template>
      <div class="line">
        <div class="bulkUpload">
          <div class="label">
            {{ "bulkorder.uploadpasteenter" | cxTranslate }}
          </div>
          <div class="txt-lable">
            <span class="part">{{ "bulkorder.uploadpartnum" | cxTranslate }}</span>
            <span class="qty">{{ "bulkorder.uploadquantity" | cxTranslate }}</span>
          </div>
          <div class="line-ht">
            <div
              *ngFor="let field of fieldArray; let i = index"
              class="line-content"
            >
            <ng-container *ngIf="!field?.isDeleted">
              <div class="content-form">
                <input
                  id="{{ i }}"
                  [(ngModel)]="field.name"
                  type="text"
                  name="{{ field.name }}"
                  (keyup)="partNo(field.name, i)"
                />
                <vs-item-counter
                  id="{{ i }}"
                  [control]="bulkQty.get('text' + i)"
                  [max]="9999"
                  (quantityIncrement)="increaseQuantity($event, i)"
                  (quantityDecrement)="decreaseQuantity($event, i)"
                  (quantityEntry)="quantityEntry($event, i)"
                >
                </vs-item-counter
                ><span class="no-qty">{{ "bulkorder.uploadeach" | cxTranslate }}</span>
                <i
                  class="material-icons"
                  (click)="deleteFieldValue(i)"
                  [ngClass]="disableDelete() < 2 ? 'disabled' : ''"
                  >delete</i
                >
              </div>
              <div *ngIf="field.showError" class="text-danger">
                {{ "bulkorder.uploadenternumb" | cxTranslate }}
              </div>
            </ng-container>
            </div>
          </div>
          <a class="link" (click)="addField()" *ngIf="fieldArray.length < 30"
            >{{ "bulkorder.uploadanotherline" | cxTranslate }}</a
          >
          <button
            class="vs-primary-btn paste-btn"
            (click)="uploadLineContent()"
          >
            <span>{{ "bulkorder.uploadcheck" | cxTranslate }}</span>
          </button>
        </div>
      </div>
    </mat-tab> -->
  </mat-tab-group>
</div>
